/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var g = require("@lexical/selection"),
    n = require("lexical");

function p(a) {
  var b = new URLSearchParams();
  b.append("code", a);

  for (var c = 1; c < arguments.length; c++) {
    b.append("v", arguments[c]);
  }

  throw Error("Minified Lexical error #".concat(a, "; visit https://lexical.dev/docs/error?").concat(b, " for the full message or ") + "use the non-minified dev environment for full errors and additional helpful warnings.");
}

function r(a, b) {
  var _iterator = _createForOfIteratorHelper(b),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      if (a.type.startsWith(c)) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

function t(a, b) {
  for (; a !== n.$getRoot() && null != a;) {
    if (b(a)) return a;
    a = a.getParent();
  }

  return null;
}

exports.$splitNode = n.$splitNode;
exports.isHTMLAnchorElement = n.isHTMLAnchorElement;
exports.isHTMLElement = n.isHTMLElement;

exports.$dfs = function (a, b) {
  var c = [];
  a = (a || n.$getRoot()).getLatest();
  b = b || (n.$isElementNode(a) ? a.getLastDescendant() : a);

  for (var e = a, d = 0; null !== (e = e.getParent());) {
    d++;
  }

  for (e = d; null !== a && !a.is(b);) {
    if (c.push({
      depth: e,
      node: a
    }), n.$isElementNode(a) && 0 < a.getChildrenSize()) a = a.getFirstChild(), e++;else for (d = null; null === d && null !== a;) {
      d = a.getNextSibling(), null === d ? (a = a.getParent(), e--) : a = d;
    }
  }

  null !== a && a.is(b) && c.push({
    depth: e,
    node: a
  });
  return c;
};

exports.$filter = function (a, b) {
  var c = [];

  for (var e = 0; e < a.length; e++) {
    var d = b(a[e]);
    null !== d && c.push(d);
  }

  return c;
};

exports.$findMatchingParent = t;

exports.$getNearestBlockElementAncestorOrThrow = function (a) {
  var b = t(a, function (c) {
    return n.$isElementNode(c) && !c.isInline();
  });
  n.$isElementNode(b) || p(4, a.__key);
  return b;
};

exports.$getNearestNodeOfType = function (a, b) {
  for (; null != a;) {
    if (a instanceof b) return a;
    a = a.getParent();
  }

  return null;
};

exports.$insertFirst = function (a, b) {
  var c = a.getFirstChild();
  null !== c ? c.insertBefore(b) : a.append(b);
};

exports.$insertNodeToNearestRoot = function (a) {
  var b = n.$getSelection() || n.$getPreviousSelection();

  if (n.$isRangeSelection(b)) {
    var _b = b,
        c = _b.focus;
    b = c.getNode();
    c = c.offset;
    if (n.$isRootOrShadowRoot(b)) c = b.getChildAtIndex(c), null == c ? b.append(a) : c.insertBefore(a), a.selectNext();else {
      var e, d;
      n.$isTextNode(b) ? (e = b.getParentOrThrow(), d = b.getIndexWithinParent(), 0 < c && (d += 1, b.splitText(c))) : (e = b, d = c);

      var _n$$splitNode = n.$splitNode(e, d);

      var _n$$splitNode2 = _slicedToArray(_n$$splitNode, 2);

      b = _n$$splitNode2[1];
      b.insertBefore(a);
      b.selectStart();
    }
  } else n.$isNodeSelection(b) || n.DEPRECATED_$isGridSelection(b) ? (b = b.getNodes(), b[b.length - 1].getTopLevelElementOrThrow().insertAfter(a)) : n.$getRoot().append(a), b = n.$createParagraphNode(), a.insertAfter(b), b.select();

  return a.getLatest();
};

exports.$restoreEditorState = function (a, b) {
  var c = new Map(),
      e = a._pendingEditorState;

  var _iterator2 = _createForOfIteratorHelper(b._nodeMap),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ref3 = _step2.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var d = _ref2[0];
      var f = _ref2[1];
      var h = g.$cloneWithProperties(f);
      n.$isTextNode(h) && (h.__text = f.__text);
      c.set(d, h);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  e && (e._nodeMap = c);
  a._dirtyType = 2;
  a = b._selection;
  n.$setSelection(null === a ? null : a.clone());
};

exports.$wrapNodeInElement = function (a, b) {
  b = b();
  a.replace(b);
  b.append(a);
  return b;
};

exports.addClassNamesToElement = function (a) {
  for (var _len = arguments.length, b = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    b[_key - 1] = arguments[_key];
  }

  b.forEach(function (c) {
    var _a$classList;

    "string" === typeof c && (c = c.split(" ").filter(function (e) {
      return "" !== e;
    }), (_a$classList = a.classList).add.apply(_a$classList, _toConsumableArray(c)));
  });
};

exports.isMimeType = r;

exports.mediaFileReader = function (a, b) {
  var c = a[Symbol.iterator]();
  return new Promise(function (e, d) {
    var f = [],
        h = function h() {
      var _c$next = c.next(),
          m = _c$next.done,
          k = _c$next.value;

      if (m) return e(f);
      var l = new FileReader();
      l.addEventListener("error", d);
      l.addEventListener("load", function () {
        var q = l.result;
        "string" === typeof q && f.push({
          file: k,
          result: q
        });
        h();
      });
      r(k, b) ? l.readAsDataURL(k) : h();
    };

    h();
  });
};

exports.mergeRegister = function () {
  for (var _len2 = arguments.length, a = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    a[_key2] = arguments[_key2];
  }

  return function () {
    a.forEach(function (b) {
      return b();
    });
  };
};

exports.objectKlassEquals = function (a, b) {
  return null !== a ? Object.getPrototypeOf(a).constructor.name === b.name : !1;
};

exports.registerNestedElementResolver = function (a, b, c, e) {
  return a.registerNodeTransform(b, function (d) {
    a: {
      var f = d.getChildren();

      for (var h = 0; h < f.length; h++) {
        if (f[h] instanceof b) {
          f = null;
          break a;
        }
      }

      for (f = d; null !== f;) {
        if (h = f, f = f.getParent(), f instanceof b) {
          f = {
            child: h,
            parent: f
          };
          break a;
        }
      }

      f = null;
    }

    if (null !== f) {
      var _f = f,
          m = _f.child,
          k = _f.parent;

      if (m.is(d)) {
        e(k, d);
        d = m.getNextSiblings();
        f = d.length;
        k.insertAfter(m);

        if (0 !== f) {
          h = c(k);
          m.insertAfter(h);

          for (var l = 0; l < f; l++) {
            h.append(d[l]);
          }
        }

        k.canBeEmpty() || 0 !== k.getChildrenSize() || k.remove();
      }
    }
  });
};

exports.removeClassNamesFromElement = function (a) {
  for (var _len3 = arguments.length, b = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    b[_key3 - 1] = arguments[_key3];
  }

  b.forEach(function (c) {
    var _a$classList2;

    "string" === typeof c && (_a$classList2 = a.classList).remove.apply(_a$classList2, _toConsumableArray(c.split(" ")));
  });
};